import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


export default {

getDicts: ( data ) => AjaxPlugin.$http.get( `/api/admin/sysDict/queryByDictType/${ data }` )
};



// WEBPACK FOOTER //
// ./src/api/dict.js